import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useCachedResource } from "../hooks/useCachedResource";
import { createPeriod, listPeriods, setPeriodStatus } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { PeriodRow } from "../features/acct/PeriodRow";
import { NeuButton, NeuInput } from "../components/neu/Neu";

export default function AcctPeriodsPage() {
  const { t } = useTranslation();
  const { data, reload: load } = useCachedResource("acct-periods", () => listPeriods().catch(() => []));
  const periods = data || [];
  const [code, setCode] = useState(new Date().toISOString().slice(0, 7));

  const add = async () => {
    await createPeriod(code);
    toast.success(t("acct.periodCreated"));
    load();
  };

  const change = async (period, status) => {
    await setPeriodStatus(period.code, status);
    toast.success(t("acct.periodUpdated"));
    load();
  };

  return (
    <AcctShell titleKey="periods">
      <div className="flex flex-wrap items-end gap-2">
        <div className="w-40">
          <p className="label-xs mb-2">{t("acct.periodCode")}</p>
          <NeuInput data-testid="period-code-input" type="month" value={code} onChange={(e) => setCode(e.target.value)} />
        </div>
        <NeuButton variant="primary" data-testid="period-add-btn" onClick={add}>
          {t("acct.openPeriod")}
        </NeuButton>
      </div>
      <div className="grid gap-3" data-testid="period-list">
        {periods.map((p) => (
          <PeriodRow key={p.code} period={p} onStatus={change} />
        ))}
      </div>
    </AcctShell>
  );
}
